/* Lleva cualquier #hash de la url a un ID existente en la pagina con una trasicion suave */
function anchorGoToHash() {
  $('a[href*="#"]:not([href="#"])').click(function (e) {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      console.log(target);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
        return false;
      }
    }
  });
}

function prefentDefaultFunction(event) {
  event.preventDefault();
}

function copyToClipboard(element){
  var copyText = $(element).html();
  navigator.clipboard.writeText(copyText).then(() => {
    $('.c-ticket__code').addClass('copied');
    setTimeout(function(){
      $('.c-ticket__code').removeClass('copied');
    }, 3000);
  });
}

function formStyles() {
  // Labels states
  $('.form-row').each(function(){
    $(this).addClass('is-label-down');
  });

  $('.form-row input, .form-row select, .form-row textarea').each(function() {
    var me = $(this),
        parent = me.parent().parent();

    if( me.val() == '' || me.val() == undefined ) {
      parent.addClass('is-label-down');
    } else {
      parent.removeClass('is-label-down');
    }
  });

  $('.form-row').find('input, select, textarea').on('keyup blur focus', function(e){

      // Cache our selectors
      var me = $(this),
          parent = me.parent().parent();

      // Add or remove classes
      if (e.type == 'keyup') {
        if( me.val() == '' ) {
          parent.addClass('is-label-down');
        } else {
          parent.removeClass('is-label-down');
        }
      } else if (e.type == 'blur') {
        if( me.val() == '' ) {
          parent.addClass('is-label-down');
        }
        else {
          parent.removeClass('is-label-down');
        }
      } else if (e.type == 'focus') {
        parent.removeClass('is-label-down');
      }
  });
}
